module.exports = __webpack_public_path__ + "3d8c74c747612ea1a5b9b4adb62d2fe5.pdf";